module.exports = "\n<div class=\"comp-accordion-item\" v-if=\"visible\" :class=\"[visible ? 'comp-accordion-item-visible' : '']\">\n  <slot></slot>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./assets/js/frontend/components/accordion_item/index.pug
// module id = 674
// module chunks = 4